<template>
  <div>
    <DynamicModal
      :showModal="showModal"
      :persistent="false"
      @clickOutside="closeModal"
      title="Reject Deal"
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="py-10">
              <v-textarea
                name="input-7-1"
                label="Write a rejection comment"
                v-model="rejectedNotes"
                outlined
                :rules="[required('Rejection comment')]"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-center">
          <div class="col-6">
            <v-btn
              block
              depressed
              color="warning"
              @click="rejectDeal"
            >
              Reject
            </v-btn>
          </div>
          <div class="col-6">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Cancel
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import { required } from '@/lib/formValidations'

export default {
  components: {
    DynamicModal
  },
  props: [
    'showModal'
  ],
  data: () => ({
    rejectedNotes: ''
  }),
  methods: {
    required,
    rejectDeal () {
      if (this.$refs.form.validate()) {
        this.$emit('reject', this.rejectedNotes)
      }
    },
    closeModal () {
      this.rejectedNotes = null
      this.$emit('closeDialog')
    }
  }
}
</script>

<style>

</style>
